var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4474 9.10563C10.28 9.0219 10.0924 8.98684 9.90607 9.00442C9.71972 9.02201 9.54205 9.09154 9.39326 9.20511C9.24448 9.31868 9.13055 9.47172 9.06445 9.64684C8.99834 9.82195 8.98271 10.0121 9.01932 10.1957L11.8254 19.8959C11.8777 20.0767 11.98 20.239 12.1204 20.3643C12.2609 20.4895 12.4339 20.5726 12.6194 20.6039L23.9997 22.51C24.5357 22.616 24.5357 23.384 23.9997 23.49L12.6194 25.3961C12.4339 25.4274 12.2609 25.5105 12.1204 25.6357C11.98 25.761 11.8777 25.9233 11.8254 26.1041L9.01932 35.8043C8.98271 35.9879 8.99834 36.1781 9.06445 36.3532C9.13055 36.5283 9.24448 36.6813 9.39326 36.7949C9.54205 36.9085 9.71972 36.978 9.90607 36.9956C10.0924 37.0132 10.28 36.9781 10.4474 36.8944L36.4481 23.894C36.6139 23.8109 36.7534 23.6832 36.8509 23.5253C36.9484 23.3675 37 23.1856 37 23C37 22.8144 36.9484 22.6325 36.8509 22.4747C36.7534 22.3168 36.6139 22.1891 36.4481 22.106L10.4474 9.10563Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/IconSend.4986332e.svg";
export { ForwardRef as ReactComponent };